import ConvertObjectToUrlParams from '../lib/utils/ConvertObjectToUrlParams'
import WalletApi from '../lib/api/Wallet'
import LogonApi from '../lib/api/Logon'
import SmsApi from '../lib/api/Sms'

const SHOPPING_URL = process.env.VUE_APP_SHOPPING_URL

function getToken() {
  const logonApi = new LogonApi()
  return logonApi
    .getToken('?features=wallet')
    .then((response) => response.data)
    .catch(() => null)
}

function getExternalToken(walletApi) {
  return walletApi
    .getExternalToken()
    .then((response) => response.data.data)
    .catch(() => null)
}

function getTrackingShopping(walletApi, data) {
  return walletApi
    .trackingVisitShopping(data)
    .then((response) => response.data)
    .catch(() => null)
}

function hasPhoneNumber(logonToken) {
  const smsApi = new SmsApi(logonToken)
  return smsApi
    .getPhoneNumber('wallet', logonToken.token_payload.user_id)
    .then((response) => response.data)
    .catch(() => ({
      pending: true,
    }))
}

export default async function redirectToShopping(to, next) {
  // get token
  const token = await getToken()

  if (token === null || !token.token) return next()

  const phone = await hasPhoneNumber(token)

  const walletApi = new WalletApi(token)

  // get summary
  const walletSummary = await walletApi.getSummary()

  if (walletSummary === null || walletSummary?.pending) return next()
  else if (
    walletSummary.owner_full_name === null &&
    walletSummary.owner_cpf === null
  )
    return next()
  else if (!phone.receiver_identifier) return next()

  // get external token
  const externalToken = await getExternalToken(walletApi)

  if (externalToken === null) return next()

  let params = ConvertObjectToUrlParams(to.query)
  params = params ? '&' + params : ''

  const data = { activity: 'visit_home' }
  await getTrackingShopping(walletApi, data)

  // redirect to shopping
  location.href =
    SHOPPING_URL + '/autenticar?token=' + externalToken.token + params
}
